<!--
 * @Author: your name
 * @Date: 2021-09-30 10:28:26
 * @LastEditTime: 2022-04-29 19:45:35
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /dmf_ad_currency_h5/src/views/modules/lincoln_national_day/components/video.vue
-->
<!--
    视频模块
-->
<template>
    <div class="video">
        <div id="video">
            <video data-v-3b1260f5="" id="vido_one" src="https://source.qunarzz.com/site/images/wns/20220429-shijianchen-video01.mp4"
            controls="controls"
            webkit-playsinline="" poster="https://s.qunarzz.com/srmweb/qunaradv/lincoln/images/7.png"
            playsinline="" x5-video-player-type="h5" class="video__player poster">
                抱歉，您的浏览器不支持内嵌视频
            </video>
        </div>  
    </div>
</template>
<script>
    import maidian from '@/utils/maidian'
    export default {
        data(){
            return {
                
            }
        },
        mounted(){
            document.getElementById('vido_one').addEventListener('play',function(){
                maidian.eventBind('playVideo')
            })
        }
    }
</script>
<style lang="less" scoped>
    .video{
        // 原封面https://picbed.qunarzz.com/9c19fc3c2b945368346daf954568cadb.png
        // margin-top:6px;
        &-tit{
            width:calc(100% - 94px);
            padding-top:40px;
            margin-left:auto;
            margin-right:auto;
            margin-bottom:18px;
        }
        video{
            width:100%;
            height: 188px;
            margin-left:auto;
            margin-right:auto;
        }
    }
</style>